import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import LayoutReducer from './LayoutReducer';
import DashboardReducer from './DashboardReducer';
import JobReducer from './JobReducer';
import TypeReducer from './TypeReducer';
import LocationReducer from './LocationReducer';
import UserReducer from './UserReducer';
import ReportReducer from './ReportReducer';
import CompanyReducer from './CompanyReducer';
import ModalReducer from './ModalReducer';

export default combineReducers({
    auth: AuthReducer,
    layout: LayoutReducer,
    dashboard: DashboardReducer,
    jobStore: JobReducer,
    typeStore: TypeReducer,
    companyStore: CompanyReducer,
    locationStore: LocationReducer,
    userStore: UserReducer,
    reportStore: ReportReducer,
    modalStore: ModalReducer,
});


// WEBPACK FOOTER //
// ./src/Reducers/index.js